
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...typeSlug]",
      function () {
        return require("private-next-pages/[...typeSlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...typeSlug]"])
      });
    }
  